const AnalyticsEventTypes = {
  REPORT_VIEW: 0,
  REPORT_COMPANY_VIEW: 1,
}

export { AnalyticsEventTypes }
